import { Component, Input, Output, EventEmitter, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { StepItem, StepSummary } from 'src/app/shared/ui/stepper/stepper.component';
import { RebateCoordinatorFormComponent } from '../rebate-coordinator-form/rebate-coordinator-form.component';

@Component({
  selector: 'app-cash-payment-workflow',
  templateUrl: './cash-payment-workflow.component.html',
  styleUrls: ['./cash-payment-workflow.component.scss']
})
export class CashPaymentWorkflowComponent implements OnInit {
  @Input() public rewardRadioSelection: string = '';
  @Input() public optInCash: boolean = false;
  @Input() public rebateForm: FormGroup | null = null;
  @Output() public submitButtonStateChanged = new EventEmitter<boolean>();

  @ViewChild(RebateCoordinatorFormComponent) rebateCoordinatorFormComponent!: RebateCoordinatorFormComponent;

  public readInstructionNextbtnFlag: boolean = false;

  public cashPaymentSteps: StepItem[] = [
    { id: 'coordinator', title: 'Step 1' },
    { id: 'learnmore', title: 'Step 2' },
    { id: 'acknowledge', title: 'Step 3' }
  ];

  public cashPaymentCurrentStep: number = 0;

  public cashPaymentStepData: { [key: string]: StepSummary } = {
    coordinator: { label: 'Coordinator Details', value: 'Provide rebate coordinator contact details', status: 'completed' },
    learnmore: { label: 'Learn More', value: 'Learn more', status: 'active' },
    acknowledge: { label: 'Acknowledge Terms', value: 'Agree and acknowledge', status: 'disabled' }
  };

  public rewardTypeSavebtn: boolean = true;

  get rebateContactForm() {
    if (this.rebateCoordinatorFormComponent != null) {
      return this.rebateCoordinatorFormComponent.form;
    }
    return null;
  }

  public ngOnInit(): void {
    this.cashPaymentCurrentStep = 0;
  }

  public onChangeCashSteps(stepName: string): void {
    const stepMap: { [key: string]: number } = {
      'step1': 0,
      'step2': 1,
      'step3': 2
    };
    this.cashPaymentCurrentStep = stepMap[stepName] != null ? stepMap[stepName] : 0;
  }

  public onClickNext(): void {
    if (this.cashPaymentCurrentStep === 0) {
      if (this.rebateContactForm != null && this.rebateContactForm.valid) {
        this.cashPaymentCurrentStep++;
      }
    } else if (this.cashPaymentCurrentStep === 1) {
      this.cashPaymentCurrentStep++;
    }
  }

  public onClickPrev(): void {
    if (this.cashPaymentCurrentStep > 0) {
      this.cashPaymentCurrentStep--;
    }
  }

  public onSubmitButtonStateChanged(isDisabled: boolean): void {
    this.rewardTypeSavebtn = isDisabled;
    this.submitButtonStateChanged.emit(isDisabled);
  }

  public patchRebateContactFormData(primaryContact: any, backupContact: any): void {
    if (this.rebateContactForm == null) {
      return;
    }

    if (primaryContact != null) {
      const primaryForm = this.rebateContactForm.get("primaryContactForm");
      if (primaryForm != null) {
        primaryForm.patchValue({
          firstName: primaryContact.firstName,
          lastName: primaryContact.lastName,
          email: primaryContact.email,
          id: primaryContact.id,
        });
      }
    }

    if (backupContact != null) {
      const backupForm = this.rebateContactForm.get("backupContactForm");
      if (backupForm != null) {
        backupForm.patchValue({
          backupFirstName: backupContact.firstName,
          backupLastName: backupContact.lastName,
          backupEmail: backupContact.email,
          id: backupContact.id,
        });
      }
    }
  }

  public getRebateContactFormData(userProfile: any): any {
    if (this.rebateContactForm == null || !this.rebateContactForm.valid) {
      return null;
    }

    let contactData = [];
    let contactFormObj: any = {};
    let backupConcatForm: any = {};
    const formData = this.rebateContactForm.value;

    if (
      formData.primaryContactForm.firstName != "" &&
      formData.primaryContactForm.lastName != "" &&
      formData.primaryContactForm.email != ""
    ) {
      contactFormObj.firstName = formData.primaryContactForm.firstName;
      contactFormObj.lastName = formData.primaryContactForm.lastName;
      contactFormObj.email = formData.primaryContactForm.email;
      contactFormObj.id = formData.primaryContactForm.id;
      contactFormObj.companyId = userProfile.company.id;
      contactFormObj.priority = 1;
      contactData.push(contactFormObj);
    }

    if (
      formData.backupContactForm.backupFirstName != null ||
      formData.backupContactForm.backupLastName != null ||
      formData.backupContactForm.backupEmail != null
    ) {
      backupConcatForm.firstName = formData.backupContactForm.backupFirstName;
      backupConcatForm.lastName = formData.backupContactForm.backupLastName;
      backupConcatForm.email = formData.backupContactForm.backupEmail;
      backupConcatForm.id = formData.backupContactForm.id;
      backupConcatForm.companyId = userProfile.company.id;
      backupConcatForm.priority = 2;
      contactData.push(backupConcatForm);
    }

    return contactData;
  }
}
